import { ProductTypes } from 'common/src/modules/products/product-types';

export function purchasePriceHints(
  activeTab?: ProductTypes | string,
  hasPrices?: boolean
) {
  const hintsList = {
    ['purchase_prices_tab_goods_1']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_1',
      attachTo: {
        element: '#servicesTab',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 30] }}]
      },
    },
    ['filter_button_purchases_price']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_9',
      attachTo: {
        element: '#filterBtn',
        on: 'bottom'
      },
    },

  }

  // const viewStateHints = {
  //   ['edit_entity_button_purchase_prices']: {
  //     text: 'MEGA_HINT.PO_PRICE.HINT_7',
  //     attachTo: {
  //       element: '#editBtn',
  //       on: 'bottom'
  //     },
  //   },
  //   ['export_button_purchase_prices']: {
  //     text: 'MEGA_HINT.PO_PRICE.HINT_8',
  //     attachTo: {
  //       element: '#exportBtn',
  //       on: 'bottom'
  //     },
  //   },
  // }

  const servicesCostColumnHint = {
    ['purchase_prices_tab_services_1']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_4',
      attachTo: {
        element: '#primeCostColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
  }

  const digitalProductsColumnHint = {
    ['purchase_prices_tab_digital_goods_1']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_5',
      attachTo: {
        element: '#purchasePriceNetColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
    ['purchase_prices_tab_digital_goods_2']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_6',
      attachTo: {
        element: '#primeCostColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
  }

  const goodsColumnHints = {
    ['purchase_prices_tab_goods_2']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_2',
      attachTo: {
        element: '#purchasePriceNetColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
    ['purchase_prices_tab_goods_3']: {
      text: 'MEGA_HINT.PO_PRICE.HINT_3',
      attachTo: {
        element: '#waPurchasePriceColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
  }

  const editStateHints = {
    ['done_button_purchase_prices']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_10',
      attachTo: {
        element: '#doneBtn',
        on: 'bottom'
      },
    },
    ['save_timer_purchase_prices']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_11',
      attachTo: {
        element: '#savedInfo',
        on: 'bottom'
      },
    },
  }

  Object.assign(hintsList, editStateHints);

  if (activeTab === ProductTypes.SERVICES && hasPrices) {
    Object.assign(hintsList, servicesCostColumnHint);
  }
  if (activeTab === ProductTypes.DIGITAL && hasPrices) {
    Object.assign(hintsList, digitalProductsColumnHint);
  }
  if (activeTab === ProductTypes.GOODS && hasPrices) {
    Object.assign(hintsList, goodsColumnHints);
  }

  return hintsList;

}

export function salesPriceHints(
  hasPrices?: boolean,
  activeTab?: ProductTypes | string
) {
  const hintsList = {
    ['sales_prices_tab_goods_1']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_1',
      attachTo: {
        element: '#servicesTab',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 30] }}]
      },
    },
    ['filter_button_sales_price']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_10',
      attachTo: {
        element: '#filterBtn',
        on: 'bottom'
      },
    },
  }

  const viewStateHints = {
    ['edit_entity_button_sales_prices']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_6',
      attachTo: {
        element: '#editBtn',
        on: 'bottom'
      },
    },
    ['export_button_sales_prices']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_7',
      attachTo: {
        element: '#exportBtn',
        on: 'bottom'
      },
    },
  }

  const columnsHint = {
    ['total_row_sales_prices']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_8',
      attachTo: {
        element: '#tableSummaryBar',
        on: 'top'
      },
    },
  }

  // const editStateHints = {
  //   ['done_button_sales_prices']: {
  //     text: 'MEGA_HINT.SALES_PRICE.HINT_9',
  //     attachTo: {
  //       element: '#doneBtn',
  //       on: 'bottom'
  //     },
  //   },
  //   ['save_timer_sales_prices']: {
  //     text: 'MEGA_HINT.SALES_PRICE.HINT_11',
  //     attachTo: {
  //       element: '#savedInfo',
  //       on: 'bottom'
  //     },
  //   },
  // }

  const servicesColumnHints = {
    ['sales_prices_tab_services_1']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_4',
      attachTo: {
        element: '#primeCostNetColumn',
        on: 'bottom'
      },
    },
  }

  const goodsColumnHints = {
    ['sales_prices_tab_goods_2']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_2',
      attachTo: {
        element: '#waPurchasesPriceNetColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
  }

  const digitalColumnsHints = {
    ['sales_prices_tab_digital_goods_1']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_5',
      attachTo: {
        element: '#marginEurColumn',
        on: 'bottom'
      },
      popperOptions : {
        modifiers : [{ name: 'offset', options: { offset : [0, 60] }}]
      },
    },
  }

  const marginEuroColumnHint = {
    ['sales_prices_tab_goods_3']: {
      text: 'MEGA_HINT.SALES_PRICE.HINT_3',
      attachTo: {
        element: '#marginEurColumn',
        on: 'bottom'
      },
    },
  }

    Object.assign(hintsList, viewStateHints);
    // Object.assign(hintsList, editStateHints);

  if (hasPrices) {
    Object.assign(hintsList, columnsHint);
  }
  if (activeTab === ProductTypes.SERVICES && hasPrices) {
    Object.assign(hintsList, servicesColumnHints);
  }
  if (activeTab === ProductTypes.GOODS && hasPrices) {
    Object.assign(hintsList, goodsColumnHints);
  }
  if (activeTab === ProductTypes.DIGITAL && hasPrices) {
    Object.assign(hintsList, digitalColumnsHints);
  }
  if (activeTab !== ProductTypes.DIGITAL && hasPrices) {
    Object.assign(hintsList, marginEuroColumnHint);
  }

  return hintsList;

}
